import React from 'react';
import User from './img/author.svg';
import {format, parseISO} from 'date-fns';
import {getLanguage} from 'react-switch-lang';
const AuditTrail = (props) => {
  const {audit} = props;
  const {actionCode, description,descriptionEn,imageUrl, insertedAt,userFirstName, userLastName} = audit;
  // const {userFirstName, userLastName} = userLogin;
  const makeInitials = () => {
    const initials = [];
    if (userFirstName) initials[0] = userFirstName[0];
    // if (?.userFirstName) initials[0] = userFirstName[0];
    if (userLastName) initials[1] = userLastName[0];
    // if (user?.userLastName) initials[1] = userLastName[0];
    return initials.join('');
}; 
const avatar = imageUrl ? (
  <img src={imageUrl} alt="Avatar"/>
) : (
  `${makeInitials()}`
);
  return (
    <div className="document-audit">
      <div className="document-audit__image">
      <div className="avatar-pic avatar-user">
         {avatar}
      </div>
      </div>
      <div className="document-audit__data">
        <div className="document-audit__info">
          <p className="document-audit__author">
            {userFirstName + ' ' + userLastName}
            {/* {userLogin} */}
          </p>
          <p className="document-audit__date">
          {/*{format(parseISO(insertedAt), 'dd.MM.yyyy. | HH:mm')}*/}
          </p>
        </div>
        <div className="document-audit__text">
          <p>{getLanguage() === "eng" ? descriptionEn : description}</p>
        </div>
      </div>
    </div>
  );
};

export default AuditTrail;